import { ConfigurationDetail, EncodingValidationRequest, EncodingValidationResponse } from 'core/api'
import { EncodingExtensions as Base } from 'core/extensions/EncodingExtensions'
import { RemoteOperation } from 'core/shared'
import { EncodingOperationConfig } from 'core/shared/RemoteOperation'

const OP_CODES_VALIDATE_REMAP_CODE = ['encoding-QR']

export class EncodingExtensions extends Base {
  static async validate(
    encodingValidationInput: EncodingValidationRequest,
    checkConfiguration = true,
    desiredCode = false,
    enabledUhfWrite = false,
    expectOnlyMandatoryIdentifiers = false
  ) {
    const cleanedInput = {
      ...encodingValidationInput,
      identifiers: encodingValidationInput.identifiers.filter((idf) => !idf._errorCode)
    }
    const res = await super.validate(
      cleanedInput,
      checkConfiguration,
      desiredCode,
      enabledUhfWrite,
      expectOnlyMandatoryIdentifiers
    )
    const encodingValidationResponse: EncodingValidationResponse = res.encodingValidationResponse
    const encodingValidation: EncodingValidationRequest = res.encodingValidation
    const opConfig = RemoteOperation.getOperationConfigById<EncodingOperationConfig>(encodingValidation.operationId)
    if (
      encodingValidation &&
      encodingValidationResponse?.item?.identifiers &&
      encodingValidationResponse.item.identifiers.length > 0 &&
      opConfig &&
      OP_CODES_VALIDATE_REMAP_CODE.includes(opConfig.code)
    ) {
      // Remapping identifiers' codes based on response from validate
      encodingValidation.identifiers = encodingValidationResponse.item?.identifiers
        .map((identifier) => {
          const orgId = encodingValidation.identifiers.find((id) => id.role === identifier.role)
          if (orgId) {
            if (!orgId.code) return orgId
            return {
              ...orgId,
              code: identifier.code
            }
          }
          return null
        })
        .filter((id) => id !== null)
    }
    return { encodingValidation, encodingValidationResponse }
  }
}
